import React, { Component } from "react";
import "../style/ResetPassword.css";

// EXTRA LIBS
import axios from "axios";
import { Redirect } from "react-router-dom";

// COMPONENTS
import Loader from "./Loader";

class ResetPasswrod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      passwordConfirm: "",
      token: null,
      formFeeback: null,
      redirect: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleInputChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }
  async handleSubmit(e) {
    e.preventDefault();
    this.setState({
      formFeeback: null
    });
    const { password, passwordConfirm } = this.state;
    if (password !== passwordConfirm) {
      this.setState({ formFeeback: "Your passwords don't match!" });
      return;
    }
    const jwt = localStorage.getItem("token");
    const data = {
      jwt,
      password
    };
    const url =
      "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/set-password";

    try {
      await axios.post(url, data);
      this.setState({ redirect: true });
    } catch (error) {
      console.log("error", error);
    }
  }
  async componentDidMount() {
    const { emailToken } = this.props.match.params;
    // Send this emailToken to a lambda that will decode it
    const url =
      "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/verify-email";
    const data = {
      emailToken
    };
    try {
      const result = await axios.post(url, data);
      const { jwt } = result.data;
      localStorage.setItem("token", jwt);
      this.setState({ token: jwt });
    } catch (error) {
      console.log("error", error);
    }
    // When it is decoded, render the password inputs

    // When the passwords are entered, update the user's
    // password in the DB
  }
  render() {
    if (this.state.token) {
      return (
        <div className="reset-password-container">
          <p>Hey, everything checked out! Now set your new password!</p>
          {this.state.formFeeback && <p>{this.state.formFeeback}</p>}
          <form onSubmit={this.handleSubmit}>
            <input
              className="sign-input"
              onChange={this.handleInputChange}
              type="password"
              value={this.state.password}
              name="password"
              placeholder="Password"
            />
            <input
              className="sign-input"
              onChange={this.handleInputChange}
              type="password"
              value={this.state.passwordConfirm}
              name="passwordConfirm"
              placeholder="Confirm password"
            />
            <div className="btn-container">
              <button className="btn" type="submit">
                Set you new password
              </button>
            </div>
          </form>
          {this.state.redirect && <Redirect to="/" />}
        </div>
      );
    } else {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Loader />
        </div>
      );
    }
  }
}

export default ResetPasswrod;



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js